var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogowhite = function SvgLogowhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FEFEFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.205 13.5c0 7.3 5.917 13.217 13.217 13.217 4.892 0 9.16-2.659 11.445-6.609l-8.177-4.721a3.77 3.77 0 0 1-3.268 1.89 3.777 3.777 0 0 1 0-7.553V.283C6.122.283.205 6.2.205 13.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.194 10.168 4.433-8.338A13.15 13.15 0 0 0 13.422.283v9.44c.64 0 1.243.163 1.772.445",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.69 11.613 8.177-4.72a13.3 13.3 0 0 0-1.627-2.234l-7.015 6.317q.265.294.465.637",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.225 10.976 23.24 4.66a13.3 13.3 0 0 0-3.613-2.829l-4.433 8.338c.39.208.738.482 1.03.808",
    opacity: 0.4
  }))));
};
export default SvgLogowhite;